export const APRA_LINK = "http://www.passengerrightsadvocates.eu/";

export const LOGOTYPES = {
  da: [
    {
      imgPath: "tv-2.svg",
      alt: "TV2 logo",
    },
    {
      imgPath: "berlingske.svg",
      alt: "Berlingske logo",
    },
    {
      imgPath: "finans.svg",
      alt: "Finans logo",
    },
    {
      imgPath: "ekstrabladet.svg",
      alt: "Ekstra Bladet logo",
    },
  ],
  de: [
    {
      imgPath: "bild.svg",
      alt: "Bild logo",
    },
    {
      imgPath: "frankfurter-allgemeine-zeitung.svg",
      alt: "Frankfurter Allgemeine Zeitung logo",
    },
    {
      imgPath: "focus-online.svg",
      alt: "Focus Online logo",
    },
    {
      imgPath: "wirtschaftswoche.svg",
      alt: "WirtschaftsWoche logo",
    },
  ],
  "de-ch": [
    {
      imgPath: "20-minuten.svg",
      alt: "20 minuten logo",
    },
    {
      imgPath: "baslerzeitung.svg",
      alt: "Basler Zeitung logo",
    },
    {
      imgPath: "blick.svg",
      alt: "Blick logo",
    },
    {
      imgPath: "handelszeitung.svg",
      alt: "Handelszeitung logo",
    },
  ],
  "de-at": [
    {
      imgPath: "kronenzeitung.svg",
      alt: "Kronen Zeitung logo",
    },
    {
      imgPath: "heute.svg",
      alt: "Heute logo",
    },
    {
      imgPath: "derstandard.svg",
      alt: "Der Standard logo",
    },
    {
      imgPath: "kurier.svg",
      alt: "Kurier logo",
    },
  ],
  el: [
    {
      imgPath: "popaganda.svg",
      alt: "POPAGANDA logo",
    },
    {
      imgPath: "kathimerini.svg",
      alt: "ΚΑΘΗΜΕΡΙΝΗ logo",
    },
    {
      imgPath: "news247.svg",
      alt: "News 247 logo",
    },
    {
      imgPath: "fortune_greece.svg",
      alt: "Fortune greece.com logo",
    },
  ],
  es: [
    {
      imgPath: "el-pais.svg",
      alt: "El País logo",
    },
    {
      imgPath: "elmundo.svg",
      alt: "El Mundo logo",
    },
    {
      imgPath: "eleconomista.svg",
      alt: "El Economista logo",
    },
    {
      imgPath: "abc.svg",
      alt: "ABC logo",
    },
  ],
  en: [
    {
      imgPath: "usa_today.svg",
      alt: "USA Today Logo",
    },
    {
      imgPath: "the-new-york-times.svg",
      alt: "The New York Times Logo",
    },
    {
      imgPath: "wsj.svg?tr=w-60,h-32,cm-extract",
      alt: "WSJ Logo",
    },
    {
      imgPath: "the-washington-post.svg",
      alt: "Washington Post",
    },
  ],
  "en-ca": [
    {
      imgPath: "torontosun.svg",
      alt: "Toronto Sun logo",
    },
    {
      imgPath: "nationalpost.svg",
      alt: "National Post logo",
    },
    {
      imgPath: "ctvnews.svg",
      alt: "CTV News logo",
    },
    {
      imgPath: "theglobalmail.svg",
      alt: "The Globe and Mail logo",
    },
  ],
  "en-gb": [
    {
      imgPath: "mirror.svg",
      alt: "The Mirror logo",
    },
    {
      imgPath: "dailyexpress.svg",
      alt: "The Express logo",
    },
    {
      imgPath: "mailonline.svg",
      alt: "The Daily Mail logo",
    },
    {
      imgPath: "business-insider.svg",
      alt: "UK Business Insider logo",
    },
  ],
  fi: [
    {
      imgPath: "kauppalehti.svg",
      alt: "Kauppalehti logo",
    },
    {
      imgPath: "yle-uutiset.svg",
      alt: "YLE Uutiset logo",
    },
    {
      imgPath: "ilta-sanomat.svg",
      alt: "Ilta-sanomat logo",
    },
    {
      imgPath: "helsingin-sanomat.svg",
      alt: "Helsingin Sanomat logo",
    },
  ],
  fr: [
    {
      imgPath: "capital.svg",
      alt: "Capital logo",
    },
    {
      imgPath: "la-figaro.svg",
      alt: "le Figaro logo",
    },
    {
      imgPath: "leparisien.svg",
      alt: "Le Parisien logo",
    },
    {
      imgPath: "europe1.svg",
      alt: "Europa1 logo",
    },
  ],
  it: [
    {
      imgPath: "ilcorrieredellasera.svg",
      alt: "Il Corriere della Sera logo",
    },
    {
      imgPath: "ilsole24ore.svg",
      alt: "Il Sole 24 ore logo",
    },
    {
      imgPath: "repubblica.svg",
      alt: "la Repubblica logo",
    },
    {
      imgPath: "toms-hardware.svg",
      alt: "Toms Hardware",
    },
  ],
  nb: [
    {
      imgPath: "dagasavisen.svg",
      alt: "Dagens Næringsliv logo",
    },
    {
      imgPath: "nrk.svg",
      alt: "NRK logo",
    },
    {
      imgPath: "aftenposten.svg",
      alt: "Aftenposten logo",
    },
    {
      imgPath: "dagens.svg",
      alt: "Dagsavisen logo",
    },
  ],
  nl: [
    {
      imgPath: "ad.svg",
      alt: "AD Logo logo",
    },
    {
      imgPath: "dsstandaard.svg",
      alt: "Metro add De Standaard",
    },
    {
      imgPath: "hln.svg",
      alt: "HLN logo",
    },
    {
      imgPath: "nos.svg",
      alt: "NOS",
    },
  ],
  pl: [
    {
      imgPath: "moneypl.svg",
      alt: "Money.pl logo",
    },
    {
      imgPath: "tokfm.svg",
      alt: "TokFM logo",
    },
    {
      imgPath: "onet.svg",
      alt: "Onet.pl logo",
    },
    {
      imgPath: "wyborcza.svg",
      alt: "Wyborcza logo",
    },
  ],
  "pt-pt": [
    {
      imgPath: "rtp1.svg",
      alt: "RTP logo",
    },
    {
      imgPath: "sicnoticias.svg",
      alt: "Sicnoticias logo",
    },
    {
      imgPath: "tvi24.svg",
      alt: "TVI 24 logo",
    },
    {
      imgPath: "dario-de-noticias.svg",
      alt: "Diário de notícias logo",
    },
  ],
  "pt-br": [
    {
      imgPath: "exame.svg",
      alt: "Exame logo",
    },
    {
      imgPath: "infomoney.svg",
      alt: "Infomoney logo",
    },
    {
      imgPath: "panrotas.svg",
      alt: "Panrotas logo",
    },
    {
      imgPath: "folha.svg",
      alt: "Folha logo",
    },
  ],
  ro: [
    {
      imgPath: "agerpres.svg",
      alt: "Agerpres logo",
    },
    {
      imgPath: "profit-ro.svg",
      alt: "Profit.ro logo",
    },
    {
      imgPath: "rtv_romania.svg",
      alt: "RTV Romania logo",
    },
    {
      imgPath: "ziarul-financiar.svg",
      alt: "Ziarul Financiar logo",
    },
  ],
  ru: [
    {
      imgPath: "bfmru.svg",
      alt: "Business FM logo",
    },
    {
      imgPath: "vedomosti.svg",
      alt: "VEDOMOSTI logo",
    },
    {
      imgPath: "the-village.svg",
      alt: "THE VILLAGE logo",
    },
    {
      imgPath: "komersant-rus.svg",
      alt: "KOMMERSANT logo",
    },
  ],
  sv: [
    {
      imgPath: "aftonbladet.svg",
      alt: "Aftonbladet logo",
    },
    {
      imgPath: "dagensnyheter.svg",
      alt: "Dagens Nyheter logo",
    },
    {
      imgPath: "expressen.svg",
      alt: "Expressen logo",
    },
    {
      imgPath: "goteborgs-posten.svg",
      alt: "Göteborgs-Posten logo",
    },
  ],
};

export const INFO_CHECKMARKS = ["all_airlines", "all_countries", "no_win_no_fee"];
